module.exports = __webpack_public_path__ + "static/media/password-panel.98514649.svg";